export default __webpack_public_path__ + "static/media/trust-exchange.8c30863f.png";